import { render, staticRenderFns } from "./VMenuButton.vue?vue&type=template&id=6384b71e&scoped=true&"
import script from "./VMenuButton.vue?vue&type=script&lang=ts&"
export * from "./VMenuButton.vue?vue&type=script&lang=ts&"
import style0 from "./VMenuButton.vue?vue&type=style&index=0&id=6384b71e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6384b71e",
  null
  
)

export default component.exports